import { useQuery } from '@tanstack/react-query';
import { AxiosInstance } from '../../../../utilities/requestClient';
import { AggregateLiquidationPageModel } from './aggLiquidation.types';

export function useAggregateLiquidationPageModel(
  section: string | undefined,
  positionDate?: string,
) {
  const sectionKey = (section || 'ucits').toUpperCase();
  const url = positionDate
    ? `aggregate_liquidation_risk_report/${sectionKey}/${positionDate}`
    : `aggregate_liquidation_risk_report/${sectionKey}`;

  return useQuery({
    queryKey: [
      'aggregate-liquidation-page-model',
      sectionKey,
      positionDate,
    ] as const,
    queryFn: async () => {
      const { data } =
        await AxiosInstance.get<AggregateLiquidationPageModel>(url);
      return data;
    },
    enabled: !!section,
    staleTime: 1000 * 60 * 5,
  });
}
